import {useEffect, useState} from "react";
import {useForm, Controller} from "react-hook-form";
import {Col, Row, notification} from "antd";
import {Button, Loading, Icon} from "~/components";
import {DateField} from "~/components/Forms";
import {employeeEvaluationApi} from "~/api";
import {apiError, handleRequest, strToTime, renderDate} from "~/utils";

function SetCycleModal({item, onSuccess}) {

	const {control, handleSubmit, reset, formState: {isSubmitting, errors}} = useForm({
		defaultValues: {start3: undefined, start7: undefined}
	});

	const [loading, setLoading] = useState(false);
	const [cycle, setCycle] = useState(null);

	//Nạp chu kỳ hiện hành của nhân viên khi mở form
	useEffect(() => {
		const load = async () => {
			if (!item?.id) return;
			setLoading(true);
			let [error, response] = await handleRequest(employeeEvaluationApi.getCycle(item.id));
			setLoading(false);
			if (!error && response?.data) {
				const d = response.data;
				setCycle(d);
				reset({
					start3: d.eval3Start ? d.eval3Start * 1000 : undefined,
					start7: d.eval7Start ? d.eval7Start * 1000 : undefined,
				});
			}
		};
		load();
	}, [item?.id, reset]);

	const onSubmit = async (data) => {
		if (!data.start3 && !data.start7) {
			notification.error({message: 'Lỗi', description: 'Vui lòng chọn mốc bắt đầu chu kỳ 3 ngày hoặc 7 ngày'});
			return;
		}

		const payload = {id: item.id};
		if (data.start3) payload.start3 = strToTime(data.start3);
		if (data.start7) payload.start7 = strToTime(data.start7);

		let [error, response] = await handleRequest(employeeEvaluationApi.setCycle(payload));

		let message = apiError('Thiết lập chu kỳ đánh giá thất bại', error, response);

		if (!message) {
			notification.success({message: 'Thành công', description: 'Thiết lập chu kỳ đánh giá thành công'});
			onSuccess && onSuccess(response.data);
		}
	};

	return (
		<form onSubmit={handleSubmit(onSubmit)} className="form">
			{(loading || isSubmitting) && <Loading/>}
			<p className="mt-1">Nhân viên: <b>{item?.firstname} {item?.lastname}</b></p>
			<p className="mt-1" style={{fontSize: '13px', color: '#999'}}>
				Ngày đánh giá được tính tự động theo chu kỳ (3 / 7 ngày dương lịch); nếu mốc rơi vào Chủ Nhật sẽ dời sang Thứ 2.
			</p>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="start3" render={({field}) => (
						<DateField label="Mốc bắt đầu chu kỳ 3 ngày" errors={errors} {...field}/>
					)}/>
					{cycle?.eval3End ? <p style={{fontSize: '13px', color: '#999'}}>Ngày đánh giá hiện tại: {renderDate(cycle.eval3End)}</p> : null}
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="start7" render={({field}) => (
						<DateField label="Mốc bắt đầu chu kỳ 7 ngày" errors={errors} {...field}/>
					)}/>
					{cycle?.eval7End ? <p style={{fontSize: '13px', color: '#999'}}>Ngày đánh giá hiện tại: {renderDate(cycle.eval7End)}</p> : null}
				</Col>
			</Row>
			<hr/>
			<div className="d-flex justify-content-end gap">
				<Button primary type="submit" leftIcon={Icon.save}>Lưu chu kỳ</Button>
			</div>
		</form>
	);
}

export default SetCycleModal;
